// extracted by mini-css-extract-plugin
export default {"datepicker":"src-components-DatePicker-SbDatePicker__datepicker--xRF4Q"};